<app-admin-dashboard>
  <p-card header="{{'AdminLoadInvoiceList.PageTitle' | translate}}">

    <!-- Formulario de Filtros -->
    <form [formGroup]="filterForm">

      <!-- Sección: Filtros -->
      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="col-12">
          <h3 class="text-base font-medium text-800 mb-3">
            {{'AdminLoadInvoiceList.FiltersSection' | translate}}
          </h3>
        </div>
      </div>

      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <!-- Tipo de perfil -->
        <div class="field col-12 md:col-6 lg:col-4">
          <label for="profileType" style="font-weight: bolder">
            {{'AdminLoadInvoiceList.ProfileTypeLabel' | translate}} *
          </label>
          <p-dropdown
            id="profileType"
            [ngModelOptions]="{standalone: true}"
            [options]="profileTypeOptions"
            optionValue="value"
            optionLabel="label"
            [filter]="true"
            filterBy="label"
            [showClear]="false"
            [(ngModel)]="selectedProfileType"
            (onChange)="onChangeProfileType($any($event).value)"
            placeholder="{{'AdminLoadInvoiceList.ProfileTypePlaceholder' | translate}}"
            class="custom-dropdown">
          </p-dropdown>
        </div>

        <div class="field col-12 md:col-6 lg:col-4"
        *ngIf="(selectedProfileType == 5 || selectedProfileType == 6)
        ">
          <label for="companyId" style="font-weight: bolder">
            {{'AdminLoadInvoice.CompanyLabel' | translate}} *
          </label>
          <p-dropdown
            id="companyId"
            formControlName="companyId"
            [options]="companies"
            optionValue="id"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="true"
            (onChange)="onProfileChange()"
            placeholder="{{'AdminLoadInvoice.CompanyPlaceholder' | translate}}"
            class="custom-dropdown">
          </p-dropdown>
        </div>

        <!-- Perfil -->
        <div class="field col-12 md:col-6 lg:col-4"  *ngIf="selectedProfileType == 1 || selectedProfileType == 2">
          <label for="profileId" style="font-weight: bolder">
            {{'AdminLoadInvoiceList.ProfileLabel' | translate}} *
          </label>
          <p-dropdown
            id="profileId"
            formControlName="profileId"
            [options]="profiles"
            optionValue="id"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="true"
            (onChange)="onProfileChange()"
            placeholder="{{'AdminLoadInvoiceList.ProfilePlaceholder' | translate}}"
            class="custom-dropdown">
          </p-dropdown>
        </div>
      </div>

      <!-- Botones de Acción -->
      <div class="p-fluid formgrid mr-2 ml-2 grid mt-2">
        <div class="col-12 md:col-6 lg:col-3">
          <p-button
            type="button"
            icon="pi pi-search"
            label="{{'AdminLoadInvoiceList.SearchButton' | translate}}"
            (onClick)="searchInvoices()"
            [loading]="loading"
            [disabled]="!canSearch"
            styleClass="p-button-primary"
            class="custom-text-button">
          </p-button>
        </div>

        <div class="col-12 md:col-6 lg:col-3">
          <p-button
            type="button"
            icon="pi pi-filter-slash"
            label="{{'AdminLoadInvoiceList.ClearButton' | translate}}"
            (onClick)="clearFilters()"
            styleClass="p-button-outlined"
            class="custom-text-button">
          </p-button>
        </div>
      </div>
    </form>

    <!-- Tabla de Resultados -->
    <div class="p-fluid formgrid mr-2 ml-2 grid mt-4" *ngIf="showResults || loading">
      <div class="col-12">
        <div class="flex justify-content-between align-items-center mb-3">
          <h3 class="text-base font-medium text-800 m-0">
            {{'AdminLoadInvoiceList.ResultsTitle' | translate}}
          </h3>
          <span class="detail-text">
            {{'AdminLoadInvoiceList.TotalRecords' | translate}}:
            <strong>{{totalRecords}}</strong>
          </span>
        </div>

        <p-table
          [value]="invoices"
          [loading]="loading"
          [paginator]="true"
          [rows]="pageSize"
          [totalRecords]="totalRecords"
          [lazy]="true"
          (onLazyLoad)="loadInvoices($event)"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          currentPageReportTemplate="{{'CommonLabels.CurrentPageReport' | translate}}"
          responsiveLayout="stack"
          [breakpoint]="'600px'"
          class="custom-table bg-header">

          <ng-template pTemplate="header">
            <tr>
              <th>
                <div class="flex align-items-center">
                  {{'AdminLoadInvoiceList.Table.NameHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex align-items-center">
                  {{'AdminLoadInvoiceList.Table.CompanyHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center align-items-center">
                  {{'AdminLoadInvoiceList.Table.CreatedDateHeader' | translate}}
                </div>
              </th>
              <th style="width: 10rem">
                <div class="flex justify-content-center align-items-center">
                  {{'AdminLoadInvoiceList.Table.ActionsHeader' | translate}}
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-invoice>
            <tr>
              <td>
                <div class="flex align-items-center">
                  <span class="font-bold">{{getInvoiceName(invoice)}}</span>
                </div>
              </td>
              <td>
                <div class="flex align-items-center">
                  {{getCompanyName(invoice)}}
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center">
                  {{invoice.created | date: 'dd/MM/yyyy'}}
                </div>
              </td>
              <td>
                <div class="flex justify-content-center align-items-center gap-2">
                  <!-- Descargar Excel -->
                  <p-button
                    icon="pi pi-download"
                    (onClick)="downloadExcel(invoice)"
                    pTooltip="{{'AdminLoadInvoiceList.DownloadTooltip' | translate}}"
                    tooltipPosition="bottom"
                    styleClass="p-button-success"
                    class="action-btn download-icon">
                  </p-button>

                  <!-- Eliminar -->
                  <p-button
                    icon="pi pi-trash"
                    (onClick)="deleteInvoice(invoice)"
                    pTooltip="{{'AdminLoadInvoiceList.DeleteTooltip' | translate}}"
                    tooltipPosition="bottom"
                    styleClass="p-button-danger"
                    class="action-btn trash-icon">
                  </p-button>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" class="text-center">
                {{'AdminLoadInvoiceList.NoResultsMessage' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

  </p-card>
</app-admin-dashboard>

<!-- Diálogo de Confirmación -->
<p-confirmDialog
  acceptLabel="{{'CommonLabels.Buttons.YesLabel' | translate}}"
  rejectLabel="{{'CommonLabels.Buttons.NoLabel' | translate}}"
  rejectButtonStyleClass="p-button-outlined"
  [style]="{width: '50vw'}">
</p-confirmDialog>
